import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { SalesRoleStep1 } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/RoleDescriptionField/SalesRoleField/SalesRolePopup/SalesRoleStep1/SalesRoleStep1';
import { SalesRoleStep2 } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/RoleDescriptionField/SalesRoleField/SalesRolePopup/SalesRoleStep2/SalesRoleStep2';
import { SalesRoleStep3 } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/RoleDescriptionField/SalesRoleField/SalesRolePopup/SalesRoleStep3/SalesRoleStep3';
import { API_VERSION } from 'src/constants/api-routes';

export const SalesRolePopup = ({
  data,
  disabled = false,
  addSalesRole,
  watch,
  roleClickValue,
  triggerClassName = '',
  titleDescription1 = '',
  titleDescription2 = '',
  titleDescription3 = '',
}) => {
  const fieldCTAValue = watch('pf_cta');
  const fieldICP = watch('pf_icp');
  const [dataStep1, setDataStep1] = useState(null);
  const [dataStep2, setDataStep2] = useState(null);
  const [dataStep3, setDataStep3] = useState(null);
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);
  const version = localStorage.getItem('API_VERSION') || API_VERSION.V1;
  const isV1 = version === API_VERSION.V1;

  useEffect(() => {
    if (fieldICP && fieldICP[0]) {
      setDataStep1(fieldICP[0]);
    }
    if (fieldICP && fieldICP[1]) {
      setDataStep2(fieldICP[1]);
    }
    if (fieldCTAValue) {
      setDataStep3(fieldCTAValue);
      return;
    }

    if (data) {
      if (data.pf_icp && data.pf_icp[0]) {
        setDataStep1(data.pf_icp[0]);
      }
      if (data.pf_icp && data.pf_icp[1]) {
        setDataStep2(data.pf_icp[1]);
      }
      if (data.pf_cta) {
        setDataStep3(data.pf_cta);
      }
    }
  }, [data]);

  useEffect(() => {
    if (roleClickValue === 'sales') {
      const isFilled = Boolean(fieldICP && fieldICP[0]);

      isV1 && setOpen(!isFilled);
    }
  }, [roleClickValue]);

  const close = () => {
    setStep(1);
    setOpen(false);
  };

  const submitStep = (data) => {
    if (step === 1) {
      setDataStep1(data);
      setStep(step + 1);
      return;
    }

    if (step === 2) {
      setDataStep2(data);
      setStep(step + 1);
      return;
    }

    if (step === 3) {
      setDataStep3(data);

      const formData = {
        pf_icp: [dataStep1, dataStep2],
        pf_cta: data,
      };

      addSalesRole(formData);
      close();
    }
  };

  const onOpenChange = (open) => {
    setOpen(open);

    if (open) {
      setStep(1);
    }
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogTrigger
          disabled={disabled}
          asChild
          className={clsx(
            triggerClassName,
            disabled && 'pointer-events-none opacity-50',
            'cursor-pointer',
          )}
        >
          {isV1 && (
            <div className={'text-[#7A6BE5] text-xs font-medium cursor-pointer hover:underline'}>
              Edit sales role
            </div>
          )}
        </DialogTrigger>
        <DialogContent closeButtonHidden>
          <DialogHeader>
            <DialogTitle className={'flex justify-between'}>
              <span className={'font-medium'}>Sales role configuration</span>
              <div className={'opacity-30 flex flex-row items-center gap-[5px]'}>
                <span className={'text-xs font-medium'}>Step {step} of 3</span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="9"
                    viewBox="0 0 9 9"
                    fill="none"
                  >
                    <path
                      d="M0 5.0625L6.84562 5.0625L3.70125 8.20688L4.5 9L9 4.5L4.5 -9.81574e-10L3.70687 0.793125L6.84562 3.9375L0 3.9375V5.0625Z"
                      fill="#05050D"
                    />
                  </svg>
                </span>
              </div>
            </DialogTitle>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="content">
              {step === 1 && (
                <SalesRoleStep1
                  titleDescription={titleDescription1}
                  data={dataStep1}
                  onSubmit={submitStep}
                  onCancel={close}
                />
              )}
              {step === 2 && (
                <SalesRoleStep2
                  titleDescription={titleDescription2}
                  data={dataStep2}
                  onPrev={() => setStep(step - 1)}
                  onSubmit={submitStep}
                  onCancel={close}
                />
              )}
              {step === 3 && (
                <SalesRoleStep3
                  titleDescription={titleDescription3}
                  data={dataStep3}
                  onPrev={() => setStep(step - 1)}
                  onSubmit={submitStep}
                  onCancel={close}
                />
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
